import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from './components/shared/ErrorBoundary';
import { ToastProvider } from './components/shared/Toast';
import AuthProvider from './components/auth/AuthProvider';
import { AppContainer } from './containers/AppContainer';

/**
 * App 组件
 * 应用入口组件
 *
 * 职责：
 * 1. 整合所有 Provider（ErrorBoundary、ToastProvider、AuthProvider、Router）
 * 2. 提供应用的最外层结构
 * 3. 不包含任何业务逻辑
 *
 * @example
 * ```tsx
 * <App />
 * ```
 */
const App = () => {
  return (
    <ErrorBoundary
      onError={(error, errorInfo) => {
        console.error('[App] Unhandled error:', error, errorInfo);
      }}
    >
      <ToastProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppContainer />
          </BrowserRouter>
        </AuthProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
};

export default App;